import { render, staticRenderFns } from "./add-member.vue?vue&type=template&id=0a249fac&scoped=true&"
import script from "./add-member.vue?vue&type=script&lang=js&"
export * from "./add-member.vue?vue&type=script&lang=js&"
import style0 from "./add-member.vue?vue&type=style&index=0&id=0a249fac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a249fac",
  null
  
)

export default component.exports